import React, { useContext, useEffect } from 'react';
import BodyClassName from 'react-body-classname';

import type { ModalContextValue } from '@swf/components/StarsModal/Context';
import { ModalContext } from '@swf/components/StarsModal/Context';
import Body from '@swf/components/StarsModal/components/Body';
import Header from '@swf/components/StarsModal/components/Header/Header';
import Translation from '@swf/components/Translation/Translation';
import { Size } from '@swf/core/models/modal';
import Spinner from '@swf/sports/components/Spinner/Spinner';

import {
  TXTWCL_Placing_your_bet,
  TXTWCL_Please_wait_while_we_validate__ELL
} from './BetDelay.messages.json';
import styles from './BetDelay.scss';

const BetDelay: React.FC = () => {
  const { setStyle } = useContext<ModalContextValue>(ModalContext);

  useEffect(
    () =>
      setStyle({
        size: Size.EXTRA_SMALL,
        className: styles.modal,
        overlayClassName: styles.overlay
      }),
    [setStyle]
  );

  return (
    <section>
      <BodyClassName className={styles.rootDisplayBlock} />
      <Header className={styles.header}>
        <Translation {...TXTWCL_Placing_your_bet} />
      </Header>
      <Body className={styles.body}>
        <Translation {...TXTWCL_Please_wait_while_we_validate__ELL} />
        <Spinner />
      </Body>
    </section>
  );
};

export default BetDelay;
